import React from "react";
import Potrait from "../assets/jay_potrait.jpg";
import { HiArrowNarrowRight } from "react-icons/hi";
import ResumePDF from "../assets/Jayant_Ghadge_Resume_2024.pdf";
import { Link } from "react-scroll";

const Home = () => {
  const downloadResume = () => {
    const link = document.createElement("a");
    link.href = ResumePDF;
    link.download = "Jayant_Ghadge_Resume.pdf";
    link.click();
  };

  return (
    <section
      id="home"
      name="home"
      className="w-full flex items-center min-h-screen bg-gradient-to-br from-[#0F172A] to-[#183250] mx-auto"
    >
      <div className="max-w-[1000px] flex flex-col items-center justify-center h-full md:flex-row sm:space-x-16 sm:p-4 w-fit md:ml-72 mx-auto">
        <img
          src={Potrait}
          alt="Jayant Ghadge"
          className="w-48 h-48 rounded-full shadow sm:w-72 sm:h-72"
          style={{ boxShadow: "0 0 10px #f4f44c" }}
        />
        <div className="w-[340px] md:w-fit flex flex-col justify-center text-center text-slate-50 mx-auto sm:mt-8 mt-14">
          <p className="text-[14px] text-left text-yellow-500">Hey there i'm</p>
          <p className="text-left w-fit">
            <b className="text-3xl leading-normal text-slate-50 lg:text-4xl">
              Jayant Ghadge
            </b>
            <br />
            <b className="text-3xl leading-tight text-yellow-200 lg:text-4xl">
              I'm a Full-Stack Developer
            </b>
          </p>
          <p className="text-[16px] text-left md:w-2/3 leading-tight mt-6">
            A Full-Stack Web Developer passionate about creating interactive
            applications and experience on the web.
          </p>
          <div className="flex gap-x-5 pt-8 md:pt-5">
            <Link to="work" spy={true} smooth={true} duration={800}>
              <button className="flex items-center px-2 mx-auto py-1 border-2 w-fit group hover:bg-yellow-600 hover:border-yellow-600 text-[16px]">
                View Work
                <HiArrowNarrowRight className="ml-2 duration-300 group-hover:rotate-90" />
              </button>
            </Link>

            <button
              className="flex items-center px-2 py-1 mx-4 border-2 w-fit group hover:bg-yellow-600 hover:border-yellow-600 text-[16px]"
              onClick={downloadResume}
            >
              Resume
              <HiArrowNarrowRight className="ml-2 duration-300 group-hover:rotate-90" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
